import gql from "graphql-tag";

export const SIGN_WEPA_STANDALONE_CONTRACT = gql`
  mutation SignWepaStandaloneContract {
    signWepaStandaloneContract {
      feedback
    }
  }
`;
